import { useSearchParams } from "react-router-dom";

/** Kiosk mode (PRD §12): `?kiosk=1` tags the source and drives auto-reset/no-persist. */
export function useKioskMode(): { isKiosk: boolean; source: "phone" | "kiosk" } {
  const [params] = useSearchParams();
  const isKiosk = params.get("kiosk") === "1";
  return { isKiosk, source: isKiosk ? "kiosk" : "phone" };
}
